import React from "react"
import WeeklyCNForm from "./weeklyCNForm"

const FeedbackForm = ({ isOpen, onClose, onSubmit }) => {
	return (
		<>
			{/* {userPermissions?.includes('write:schedules') ? (
                <DailyCNForm 
                    isOpen={isOpen}
                    onClose={onClose}
                    onSubmit={onSubmit}
                />
            ) : (
                <DailyFNForm 
                    isOpen={isOpen}
                    onClose={onClose}
                    onSubmit={onSubmit}
                />
            )} */}
			<WeeklyCNForm isOpen={isOpen} onClose={onClose} onSubmit={onSubmit} />
		</>
	)
}

export default FeedbackForm
